import { GetApplicationResponse } from '@iwoca/lapi-client/edge';

import { normaliseStepDataDE } from '../../components/helpers/stateNormalisation';
import {
  APPLICANT_STEP_ID,
  BUSINESS_STEP_ID,
} from '../../components/helpers/steps';
import {
  businessStepValidatorDE,
  passesStep0ValidationDE,
  personalStepValidatorDE,
} from '../../components/helpers/stepValidators/stepValidatorsDE';
import { TGetStateResponseDE } from '../../lapiOverrideTypesDE';
import { TSignupStepsDE } from '../../types';

export const getLatestStepDE = (
  newState: TGetStateResponseDE['data'],
  newApplication: GetApplicationResponse['data'],
  activeStep?: TSignupStepsDE,
): TSignupStepsDE => {
  const normalisedState = normaliseStepDataDE({ data: newState });

  const passesStep0 = passesStep0ValidationDE(
    normalisedState['new'],
    newApplication,
  );

  if (!passesStep0) {
    return 'neu';
  }

  if (activeStep) {
    return activeStep;
  }

  const passesBusinessStep = businessStepValidatorDE(
    normalisedState[BUSINESS_STEP_ID],
  );

  if (!passesBusinessStep) {
    return 'schritt-1';
  }

  const passesApplicantStep = personalStepValidatorDE(
    normalisedState[APPLICANT_STEP_ID],
  );

  if (!passesApplicantStep) {
    return 'schritt-2';
  }

  return 'schritt-3';
};
